import { FetchError } from "@medusajs/js-sdk";
import {
  QueryKey,
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
  useQueryClient,
} from "@tanstack/react-query";
import type {
  AdminPutTryOnSettingsBody,
  AdminTryOnSettingsResponse,
} from "@sgflabs/opticomm-sdk";
import { opticomm } from "../../lib/client";
import { queryKeysFactory } from "../../lib/query-key-factory";

export const adminTryOnSettingsQueryKey = queryKeysFactory("adminTryOnSettings");

export const useAdminTryOnSettings = (
  options?: UseQueryOptions<
    AdminTryOnSettingsResponse,
    FetchError,
    AdminTryOnSettingsResponse,
    QueryKey
  >
) => {
  return useQuery({
    queryKey: adminTryOnSettingsQueryKey.details(),
    queryFn: () =>
      opticomm.admin.opticomm.getTryOnSettings<AdminTryOnSettingsResponse>(),
    ...options,
  });
};

export const useUpdateAdminTryOnSettings = (
  options?: UseMutationOptions<
    AdminTryOnSettingsResponse,
    FetchError,
    AdminPutTryOnSettingsBody
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: AdminPutTryOnSettingsBody) =>
      opticomm.admin.opticomm.updateTryOnSettings<AdminTryOnSettingsResponse>(
        payload
      ),
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: adminTryOnSettingsQueryKey.details(),
      });

      options?.onSuccess?.(data, variables, onMutateResult, context);
    },
    ...options,
  });
};
